import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-staff-default-layout',
  templateUrl: './staff-default-layout.component.html',
  styleUrls: ['./staff-default-layout.component.scss']
})
export class StaffDefaultLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
